import styled from "styled-components";

// styles
import colors from "core/colors";

// styled-components
export const H1Styled = styled.h1`
    font-size: 1.375rem; /* 22px */
    line-height: 1.249375;
    margin-bottom: 1rem; /* 16px */
    color: ${colors.primary.diamond};
`;
